export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11632.2ef94d57.jpg";